import CustomOSSClient from '../../../../util/CustomOSSClient'

export async function getInformationFromOSS (wordList) {
  const ossClient = new CustomOSSClient()
  await ossClient.init()
  wordList.map(word => {
    if (word.us_pron && word.us_pron.length > 0) {
      word.us_pron = ossClient.getSignedUrl(word.us_pron)
    }

    if (word.uk_pron && word.uk_pron.length > 0) {
      word.uk_pron = ossClient.getSignedUrl(word.uk_pron)
    }

    if (word.ch_pron && word.ch_pron.length > 0) {
      word.ch_pron = ossClient.getSignedUrl(word.ch_pron)
    }

    if (word.picture && word.picture.length > 0) {
      word.picture = ossClient.getSignedUrl(word.picture)
    }

    if (word.video && word.video.length > 0) {
      word.video = ossClient.getSignedUrl(word.video)
    }

    if (word.sentence) {
      if (word.sentence.us_pron && word.sentence.us_pron.length > 0) {
        word.sentence.us_pron = ossClient.getSignedUrl(word.sentence.us_pron)
      }
      if (word.sentence.uk_pron && word.sentence.uk_pron.length > 0) {
        word.sentence.uk_pron = ossClient.getSignedUrl(word.sentence.uk_pron)
      }
      if (word.sentence.ch_pron && word.sentence.ch_pron.length > 0) {
        word.sentence.ch_pron = ossClient.getSignedUrl(word.sentence.ch_pron)
      }
    }

    return word
  })
  delete ossClient.client

  return wordList
}
